import { Entity } from "../../../entity"
import { IEnumerable } from "../../../enumerable";

export interface IReportType extends IEnumerable {
  name: 'cenec' | 'criteria' | 'deadlines' | 'results';
}

export class ReportType extends Entity implements IReportType {
  name: 'cenec' | 'criteria' | 'deadlines' | 'results';

  get nameKey(): string {
    return `pages.xunta.reportType.types.${this.name}`;
  }

  constructor(data: IReportType) {
    super(data);
    this.name = data.name;
  }
}

export class ReportTypesData {
  static periods: ReportType[] = [
    new ReportType({ id: 'cenec', name: 'cenec', createdAt: new Date(), updatedAt: new Date() }),
    new ReportType({ id: 'criteria', name: 'criteria', createdAt: new Date(), updatedAt: new Date() }),
    new ReportType({ id: 'deadlines', name: 'deadlines', createdAt: new Date(), updatedAt: new Date() }),
    new ReportType({ id: 'results', name: 'results',  createdAt: new Date(), updatedAt: new Date() }),
  ];

  static getAllPeriodTypes(): ReportType[] {
    return this.periods;
  }
}
